import { DAEMON_URL } from "../config";
import { HttpError } from "./errors";

export type DeployServer = { id: string; label: string };

export async function listDeployServers(): Promise<DeployServer[]> {
  let res: Response;
  try {
    res = await fetch(`${DAEMON_URL}/deploy/servers`, { headers: { Accept: "application/json" }, credentials: "include" });
  } catch (e) { throw new Error(`network error: ${(e as Error).message}`); }
  if (res.status === 401) throw new HttpError(401, "unauthorized");
  if (!res.ok) throw new HttpError(res.status, `http ${res.status}`);
  return ((await res.json()) as { servers: DeployServer[] }).servers;
}

export type DeployResult = { server: string; serverLabel: string; jar: string; commit: string; bytes: number; remotePath: string };

export async function deployPlugin(project: string, branch: string, server: string): Promise<DeployResult> {
  let res: Response;
  try {
    res = await fetch(`${DAEMON_URL}/deploy/plugin`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "include",
      body: JSON.stringify({ project, branch: branch.trim() || undefined, server }),
    });
  } catch (e) { throw new Error(`network error: ${(e as Error).message}`); }
  if (res.status === 401) throw new HttpError(401, "unauthorized");
  if (res.status === 403) throw new HttpError(403, "forbidden: no access to this project");
  if (!res.ok) {
    let msg = `http ${res.status}`;
    try { const j = (await res.clone().json()) as { error?: string; message?: string }; msg = j.message || j.error || msg; } catch { /* not json */ }
    throw new HttpError(res.status, msg);
  }
  return (await res.json()) as DeployResult;
}
